import React, { useEffect, useRef, useState } from "react";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import StepContent from "@material-ui/core/StepContent";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import {
  Grid,
  FormControlLabel,
  Checkbox,
  StepConnector,
  withStyles,
} from "@material-ui/core";

import clsx from "clsx";
import { AddCircleOutlined, Check } from "@material-ui/icons";
import BasicInfo from "../StepperComponent/BasicInfo";
// import NDA from '../Partner/NDA';
import DueDiligence from "../StepperComponent/DueDiligence";
import Questionnaire from "../StepperComponent/Questionnaire";
import WorkingWithAcuity from "../StepperComponent/WorkingWithAcuity";
import HeaderMenu from "../../../Components/HeaderMenu";
import ContractDocumentition from "../StepperComponent/ContractDocumentition";
import OtherQue from "../StepperComponent/OtherQuestions";
import NDA from "../StepperComponent/NDA";
// import OtherQuestions from '../Partner/OtherQuestions';
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import MaterialTable from "material-table";
import HomeHeaderMenu from "../../Home/HomeHeaderMenu";
import { useHistory } from "react-router";
import CoachingProfileField from "../StepperComponent/CoachingProfileField";
import AssessmentProfile from "../StepperComponent/AssessmentProfile";
import AssociateCoaches from "../StepperComponent/Associate_Coaches";
import FacilitationProfile from "../StepperComponent/FacilititationProfile";
import MentoringProfile from "../StepperComponent/MentoringProfile";
import NotFound from "../StepperComponent/NotFound";
import GeneralProfile from "../StepperComponent/GeneralProfile";
import Gdpr from "../StepperComponent/Gdpr";
import { useSelector } from "react-redux";
import moment from "moment";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: "100%",
    },
    button: {
      marginTop: theme.spacing(1),
      marginRight: theme.spacing(1),
    },
    actionsContainer: {
      marginBottom: theme.spacing(2),
    },
    resetContainer: {},
    stepIcon: {
      color: "green",
    },
  })
);
const QontoConnector = withStyles({
  root: {
    color: "#eaeaf0",
    display: "flex",
    height: 20,
    alignItems: "left",
    marginLeft: 8,
  },

  active: {
    "& $line": {
      borderColor: "#784af4",
    },
    marginLeft: 9,
    height: 20,
  },
  completed: {
    "& $line": {
      borderColor: "#784af4",
    },
    marginLeft: 9,
    height: 20,
  },
  line: {
    height: 18,
    marginLeft: "55px",
  },
  stepIcon: {
    color: "green",
  },
})(StepConnector);
const useQontoStepIconStyles = makeStyles({
  root: {
    color: "#eaeaf0",
    display: "flex",
    height: 22,
    alignItems: "left",
  },
  active: {
    color: "#784af4",
  },
  circle: {
    width: 8,
    height: 8,
    borderRadius: "50%",
    backgroundColor: "#EF7000",
  },
  completed: {
    color: "#fff",
    backgroundColor: "#EF7000",
    zIndex: 1,
    fontSize: 14,
    borderRadius: "50%",
    padding: 3,
  },
});
function QontoStepIcon(props: any) {
  const classes = useQontoStepIconStyles();
  const { active, completed } = props;
  return (
    <div
      className={clsx(classes.root, { [classes.active]: active })}
      style={{ display: "flex", alignItems: "center" }}
    >
      {active ? (
        <div
          style={{
            borderColor: "#EF7000",
            borderWidth: 1,
            padding: 3,
            backgroundColor: "#fff",
            borderRadius: "50%",
            width: 8,
            height: 8,
            borderStyle: "solid",
          }}
        >
          <div className={classes.circle} />
        </div>
      ) : completed ? (
        <div>
          <Check className={classes.completed} />
        </div>
      ) : (
        <div
          style={{
            borderColor: "#EF7000",
            borderWidth: 1,
            padding: 3,
            backgroundColor: "#fff",
            borderRadius: "50%",
            width: 8,
            height: 8,
            borderStyle: "solid",
          }}
        ></div>
      )}
    </div>
  );
}

function getSteps() {
  return [
    "Information and contact area",
    "NDA",
    "Working with Acuity Coaching (WWA)",
    "Additional Partner Information",
    "Commercials and Delivery",
    "General Profile Fields",
    "Coaching Profile Fields",
    "Facilitation Profile Fields",
    "Mentoring Profile Fields",
    "Assessment Profile Fields",
    "GDPR",
  ];
}

function OnboardingPartner() {
  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(0);
  const steps = getSteps().filter((el) => el !== "GDPR");
  const history = useHistory();
  const global_data = useSelector((state: any) => state.stepperReducer);
  // console.log(`global_data`, global_data)

  const [facilitation, setFacilitation] = React.useState(
    global_data.facilitation_flag
  );
  const [Mentoring, setMentoring] = React.useState(global_data.mentoring_flag);

  const [profileID, setProfileID] = React.useState(0);
  const [acuityProfileID, setAcuityProfileID] = useState(0);

  const updateProfileId = (profileID: any, acuityProfileID: any) => {
    setProfileID(profileID);
    setAcuityProfileID(acuityProfileID);
  };
  function getStepContent(step: any) {
    switch (step) {
      case 0:
        return (
          <BasicInfo
            parentSetProfileId={updateProfileId}
            parentHandleNext={handleNext}
            activeIndex={step}
          />
        );
      case 1:
        return global_data.partner_nda_id ? (
          <NDA
            profileId={profileID}
            parentHandleNext={handleNext}
            activeIndex={step}
          />
        ) : (
          <NotFound
            title="
                Non disclosure agreement (NDA)"
          />
        );
      // case 2:
      //     return <DueDiligence profileId={profileID} parentHandleNext={handleNext} activeIndex={step} />;
      case 2:
        return global_data.partner_wwa_id ? (
          <WorkingWithAcuity
            profileId={profileID}
            parentHandleNext={handleNext}
            activeIndex={step}
          />
        ) : (
          <NotFound
            title="
                Working with Acuity Coaching (WWA)"
          />
        );
      case 3:
        return (
          <Questionnaire
            profileId={profileID}
            parentHandleNext={handleNext}
            activeIndex={step}
          />
        );

      // case 4:
      //     return <ContractDocumentition profileId={profileID} acuityProfileID={acuityProfileID} parentHandleNext={handleNext} activeIndex={step} />;
      case 4:
        return (
          <OtherQue
            profileId={profileID}
            parentHandleNext={handleNext}
            activeIndex={step}
          />
        );
      case 5:
        return (
          <GeneralProfile
            profileId={profileID}
            parentHandleNext={handleNext}
            activeIndex={step}
          />
        );
      case 6:
        return global_data.coach_flag ? (
          <CoachingProfileField
            profileId={profileID}
            parentHandleNext={handleNext}
            activeIndex={step}
          />
        ) : (
          <NotFound
            title="
                    Coaching Profile Field"
          />
        );
      case 9:
        return global_data.assessor_flag ? (
          <AssessmentProfile
            profileId={profileID}
            parentHandleNext={handleNext}
            activeIndex={step}
          />
        ) : (
          <NotFound
            title="
                            Assessment Profile"
          />
        );
      case 7:
        return global_data.facilitation_flag ? (
          <FacilitationProfile
            profileId={profileID}
            parentHandleNext={handleNext}
            activeIndex={!Mentoring ? step + 1 : step}
          />
        ) : (
          <NotFound title="Facilitation Profile" />
        );
      case 8:
        return global_data.mentoring_flag ? (
          <MentoringProfile
            profileId={profileID}
            parentHandleNext={handleNext}
            activeIndex={step}
          />
        ) : (
          <NotFound
            title="
                                                    Mentoring Profile"
          />
        );

      // case 10:
      //     return <Gdpr profileId={profileID} parentHandleNext={handleNext} activeIndex={step} />;
      default:
        return "Not available";
    }
  }
  console.log(activeStep, "active step");
  const handleNext = (index: any) => {
    setActiveStep(index);
    window.scroll({ top: 0 });
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };
  const firstElementRef = useRef(null);
  useEffect(() => {
    console.log("running condition");
    window.scrollTo(1000, 0);
    if (firstElementRef.current) {
      //@ts-ignore
      firstElementRef.current.scrollIntoView();
    }
  });


  return (
    <div className={classes.root} ref={firstElementRef}>
      {

      sessionStorage.getItem("role") == "partner" ? (
        <HomeHeaderMenu />
      ) : (
        <HeaderMenu />
      )}
      {/* <Grid direction="row" >
                <Grid xs={12} style={{ textAlign: "left" }}>
                    <div style={{ height: 60 }}></div>
                </Grid>
            </Grid> */}

      <Grid
        container
        item
        xs={12}
        // direction="column"
        justifyContent='flex-start'
        alignItems='flex-end'
        style={{
          backgroundColor: "#F7F7F7",
          maxWidth: "35%",
          marginRight: 0,
          marginLeft: "auto",
          padding: "8px",
          marginTop: "16px",
        }}
      >
        <Grid xs={5}>Last assignment date</Grid>
        <Grid xs={2}> : </Grid>
        <Grid xs={5}>
          {global_data.last_assignment_date
            ? moment(global_data.last_assignment_date, "DD/MM/YYYY").format(
                "DD-MM-YYYY"
              )
            : "-"}
        </Grid>
        <Grid xs={5}>No of assignments</Grid>
        <Grid xs={2}> : </Grid>
        <Grid xs={5}>{global_data.no_of_assignment}</Grid>
        <Grid xs={5}>Next available date</Grid>
        <Grid xs={2}> : </Grid>
        <Grid xs={5}>
          {global_data?.currently_available_for_assignment === "true"
            ? "Available Now"
            : global_data.next_available_date
            ? moment(global_data.next_available_date).format("DD-MM-YYYY")
            : "-"}
        </Grid>
        <Grid xs={5}>Minimum coach rate</Grid>
                <Grid xs={2}> : </Grid>
                <Grid xs={5}>
                  {global_data?.coaching_hr_id?.length > 0
                    ? global_data?.coaching_hr_id.map((rate: any) => (
                        <Grid xs={5}>{rate}</Grid>
                      ))
                    : "-"}
                </Grid>
                </Grid>
      <Grid
        container
        direction='row'
        justifyContent='center'
        alignItems='center'
      >
        <Grid
          item
          xs={3}
          style={{
            paddingTop: 18,
            textAlign: "left",
            backgroundColor: "#F7F7F7",
            height: "calc(100vh - 64px)",
            zIndex: 1,
          }}
        >
          <Typography
            variant='h1'
            style={{
              marginLeft: "55px",
              paddingBlock: 25,
              textAlign: "left",
              alignSelf: "center",
              fontSize: 26,
              color: "#077F83",
              fontWeight: "bold",
            }}
          >
            <ArrowBackIosIcon
              style={{ fontSize: 16, color: "#077F83" }}
              onClick={() => {
                history.goBack();
              }}
            />{" "}
            Partner Information
          </Typography>

          <Stepper
            activeStep={activeStep}
            orientation='vertical'
            connector={<QontoConnector />}
            style={{ backgroundColor: "rgb(247, 247, 247)" }}
            nonLinear
          >
            {steps.map((label, index) => (
              <Step
                key={label}
                style={{ marginLeft: "55px", width: "100%", maxWidth: "280px" }}
              >
                <StepLabel
                  StepIconProps={{
                    classes: { root: classes.stepIcon },
                  }}
                  style={{ cursor: "pointer", margin: 0, padding: 0 }}
                  color='primary'
                  StepIconComponent={QontoStepIcon}
                  onClick={() => {
                    handleNext(index);
                    window.scroll({ top: 0 });
                  }}
                >
                  <Typography
                    variant='h2'
                    style={{ color: "rgb(7, 127,131)", fontSize: "14px" }}
                  >
                    {label}
                  </Typography>
                </StepLabel>
              </Step>
            ))}
          </Stepper>
        </Grid>
        <Grid
          item
          xs={9}
          style={{ height: "calc(100vh - 64px)", overflow: "auto" }}
        >
          {getStepContent(activeStep)}
          {activeStep === steps.length && (
            <Paper square elevation={0} className={classes.resetContainer}>
              <Typography>
                All steps completed - you&apos;re finished
              </Typography>
              <Button
                disableElevation
                onClick={handleReset}
                className={classes.button}
              >
                Reset
              </Button>
            </Paper>
          )}
        </Grid>
      </Grid>
    </div>
  );
}

export default OnboardingPartner;
